module.exports = __webpack_public_path__ + "static/media/rightArrow.43397bca.png";